/* eslint-disable newline-per-chained-call */
import _ from 'lodash';

export function toSnakeCase(s) {
  return s.replace(/([A-Z])/g, ($1) => `-${$1.toLowerCase()}`
  );
}

export function toCamelCase(s) {
  return s.replace(/(_[a-z])/g, ($1) => $1.toUpperCase().replace('_', ''));
}

export function typeToClassname(s) {
  return toSnakeCase(s.trim());
}

export function stringCount(s, length = 0) {
  if (!_.isString(s)) {
    // Do nothing if not a string.
    return s;
  }

  const strLength = length || s.length;

  return strLength;
}

export function ellipsis(s, length = 0, ellipsisChar = '...') {
  if (!_.isString(s)) {
    // Do nothing if not a string.
    return s;
  }
  const strLength = length || s.length;

  if (s.length > strLength) {
    return s.substr(0, strLength) + ellipsisChar;
  }
  return s;
}

export function ellipsisByWord(s, maxLength = 0, ellipsisChar = '...') {
  if (!_.isString(s)) {
    // Do nothing if not a string.
    return s;
  }
  const wordLength = s.split(/\s/).length;
  const length = maxLength || wordLength;
  const re = /[^a-zA-Z0-9]+$/;
  const newS = s.split(/\s/).slice(0, length).join(' ');

  if (newS.length === s.length) {
    return s;
  }

  return `${newS.replace(re, '')}${ellipsisChar}`;
}

export function widowBreaker(str) {
  if (!_.isString(str)) {
    // Do nothing if not a string.
    return str;
  }
  const words = str.split(' ');
  if (words.length > 3) {
    const one = words.pop();
    const two = words.pop();
    const clean = [two, String.fromCharCode(160), one].join('');
    words.push(clean);
  }
  return words.join(' ');
}



// WEBPACK FOOTER //
// ./src/lib/string_utils.js